import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { saveCredentials } from '../../redux/actionCreators/session';
import { sessionSelector } from '@rexmas/rexmas-shared/lib/redux/selectors/session';
import UnauthenticatedApp from './UnanthenticatedApp';

function Main({ session }) {
  return !session.isLoggedIn ? <UnauthenticatedApp /> : null;
}

Main.propTypes = {
  session: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  session: sessionSelector(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  saveCredentialsAction: saveCredentials,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Main);
